import { GlassDamageModalSection } from '@shared/insurer';
import { isSectionEnabled } from '@declaration/helpers/glassDamageModalConfig';
/**
 * [CLAIMS_CONTEXT]
 * purpose: Builds validation constraints for glass damage form sections.
 * touches: insurer load, behavior, CI
 * invariants: section enablement must use typed damage kind or null, no string sentinel
 * inputs: glass damage payload, selfCareSettings from validation context
 * outputs: validation constraints for UI and API validation
 * see: frontend/src/shared/validator/validator.ts, frontend/src/declaration/helpers/glassDamageModalConfig.ts, .circleci/config.yml
 */
function defaultConstraints(glassDamage, context) {
    var _a, _b, _c, _d, _e, _f;
    // Extract selfCareSettings from context
    const selfCareSettings = (_c = (_b = (_a = context.settings) === null || _a === void 0 ? void 0 : _a.find((setting) => setting.name === 'selfCareSettings')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : null;
    return {
        type: {
            presence: {
                allowEmpty: false,
                message: 'claim.damage.glass_damage.form.type.validator.presence',
            },
        },
        ...(isSectionEnabled((_d = glassDamage.type) !== null && _d !== void 0 ? _d : null, GlassDamageModalSection.DamageDescription, selfCareSettings)
            ? {
                numberOfPanes: {
                    presence: {
                        allowEmpty: false,
                        message: 'claim.damage.glass_damage.form.number_of_panes.validator.presence',
                    },
                    numericality: {
                        onlyInteger: true,
                        greaterThanOrEqualTo: 1,
                        message: 'claim.damage.glass_damage.form.number_of_panes.validator.numericality',
                    },
                },
                widestPaneWidth: {
                    presence: {
                        allowEmpty: false,
                        message: 'claim.damage.glass_damage.form.widest_pane_width.validator.presence',
                    },
                    numericality: {
                        onlyInteger: true,
                        greaterThanOrEqualTo: 1,
                        message: 'claim.damage.glass_damage.form.widest_pane_width.validator.numericality',
                    },
                },
                widestPaneHeight: {
                    presence: {
                        allowEmpty: false,
                        message: 'claim.damage.glass_damage.form.widest_pane_height.validator.presence',
                    },
                    numericality: {
                        onlyInteger: true,
                        greaterThanOrEqualTo: 1,
                        message: 'claim.damage.glass_damage.form.widest_pane_height.validator.numericality',
                    },
                },
            }
            : {}),
        ...(isSectionEnabled((_e = glassDamage.type) !== null && _e !== void 0 ? _e : null, GlassDamageModalSection.GlazingType, selfCareSettings)
            ? {
                glazingType: {
                    presence: {
                        allowEmpty: false,
                        message: 'claim.damage.glass_damage.form.glazing_type.validator.presence',
                    },
                },
            }
            : {}),
        ...(isSectionEnabled((_f = glassDamage.type) !== null && _f !== void 0 ? _f : null, GlassDamageModalSection.GlassType, selfCareSettings)
            ? {
                glassType: {
                    presence: {
                        allowEmpty: false,
                        message: 'claim.damage.glass_damage.form.glass_type.validator.presence',
                    },
                },
            }
            : {}),
    };
}
export function glassDamageConstraints(glassDamage, context) {
    switch (glassDamage.type) {
        default:
            return defaultConstraints(glassDamage, context);
    }
}
